var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Icon, Tooltip } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classNames from 'classnames';
import { Component } from 'react';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { getMetaWorkingMedia } from 'utils/channels/media';
import { analytics } from '../../../app/utils/segment';
import { numberFormatterInternational } from '../../../app/utils/telephonyHelpers';
import { buttonize } from '../../shared/util/buttonize';
import MediaChannelBadges from './MediaChannelBadges';
import { PresenceDropdown } from './PresenceDropdown';
import styles from './profile.module.scss';
import './../styles/profile.less';
class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDropdown: false,
        };
    }
    changeYourStatus(location) {
        if (this.props.presence.status === 'working') {
            this.props
                .presenceSetStatus('away')
                .then(() => analytics.presenceUpdated({ status: 'away', location }));
        }
        else {
            this.props
                .presenceSetStatus('working')
                .then(() => analytics.presenceUpdated({ status: 'working', location }));
        }
    }
    toggleSimultaneousRing(location = 'topbar') {
        if (this.props.profile &&
            this.props.profile.phone_number &&
            typeof this.props.organization.trial_ended_at === 'string') {
            this.props
                .presenceSetSimultaneousRinging(!this.props.presence.presence_status.simultaneous_ringing)
                .then((response) => {
                this.props.notificationRemoveByType('simring-on');
                if (response.data.enabled === true) {
                    const phoneNumber = numberFormatterInternational({
                        phoneNumber: this.props.profile.phone_number,
                    });
                    // Show notification that simultaneous ring is now enabled.
                    const options = {
                        type: 'simring-on',
                        title: 'Simultaneous ring enabled',
                        text: `You will now receive calls on the phone number ${phoneNumber}`,
                        time: 10000,
                    };
                    this.props.notificationAdd(options);
                }
                analytics.simultaneousRingUpdated({
                    enabled: response.data.enabled,
                    location,
                });
            });
        }
    }
    getPresenceStatus(presence, numberOfAcw) {
        if (presence.status !== 'offline' && numberOfAcw > 0) {
            return 'in wrap-up time';
        }
        if (['working', 'away', 'offline'].includes(presence.status)) {
            return presence.status;
        }
        return 'offline';
    }
    getOppositePresenceStatus(presence) {
        switch (presence.status) {
            case 'working':
                return 'away';
            case 'away':
                return 'working';
            case 'offline':
            default:
                return 'online';
        }
    }
    getIconClass(presence, numberOfAcw) {
        if (presence.status !== 'offline' && numberOfAcw > 0) {
            return 'clock';
        }
        return 'working';
    }
    render() {
        const { hasPhoneChannel, organization, presence, presenceMeta, profile } = this.props;
        const numberOfAcw = this.props.presence.presence_status.load_descriptions.filter(({ load_type }) => load_type === 'acw').length;
        const isInTrial = typeof organization.trial_ended_at === 'string' ? false : true;
        let simultaneousRingingActiveBadge = ' away';
        let simultaneousRingingText = isInTrial === false
            ? 'Simultaneous ring is turned off'
            : 'Simultaneous is turned off because you are in trial.';
        const presenceStatus = this.getPresenceStatus(presence, numberOfAcw);
        const oppositePresenceStatus = this.getOppositePresenceStatus(presence);
        const iconClasses = this.getIconClass(presence, numberOfAcw);
        let validPhoneNumber = false;
        const metaWorkingMedia = getMetaWorkingMedia(presence.working_channels);
        if (profile.phone_number !== null &&
            presence.presence_status.simultaneous_ringing === true) {
            simultaneousRingingActiveBadge = ' active working';
            simultaneousRingingText = `Simultaneous ring is turned on ${numberFormatterInternational({ phoneNumber: profile.phone_number })}`;
        }
        else {
            simultaneousRingingActiveBadge = ' disabled';
        }
        if (this.props.profile && this.props.profile.phone_number) {
            validPhoneNumber = true;
        }
        const presenceTooltipContent = (_jsxs(CommandKeybindingsTooltipContent, Object.assign({ commandName: "app:togglePresence" }, { children: ["You are ", presenceStatus, ". Click to set ", oppositePresenceStatus] })));
        return (_jsxs("div", Object.assign({ className: classNames(`topbar-presence`, this.props.className), tabIndex: 0 }, { children: [_jsxs("span", Object.assign({ className: styles.avatarContainer }, { children: [this.props.isSmall && (_jsx("span", { className: classNames(styles.avatarBadge, {
                                [styles.avatarBadgeWorking]: this.props.presence.status === 'working',
                                [styles.avatarBadgeAway]: this.props.presence.status === 'away',
                            }) })), _jsx(Avatar, { user: profile, size: "24" })] })), !this.props.isSmall && (_jsxs("div", Object.assign({ className: "mystatus noselect" }, { children: [_jsx("span", Object.assign({ className: "badge-item no-margin status" }, { children: _jsx(Tooltip, Object.assign({ content: presenceTooltipContent, dark: true, wrap: "none" }, { children: _jsx("span", Object.assign({}, buttonize(() => this.changeYourStatus('topbar')), { className: "profile-presence-icon-big" }, { children: _jsx(Icon, { name: iconClasses, size: 24, className: `${this.props.presence.status} badge-btn ${presenceMeta.asyncStatus === 'loading'
                                            ? 'icon-animated'
                                            : ''}` }) })) })) })), _jsx("span", Object.assign({ className: `${this.props.presence.status} badges-icons` }, { children: metaWorkingMedia.map((metaMedia) => (_jsx(MediaChannelBadges, { presenceMeta: presenceMeta, telephony: this.props.telephony, presence: this.props.presence, presenceSetMedia: this.props.presenceSetMedia, errorMicrophoneErrorShowModal: this.props.errorMicrophoneErrorShowModal, personalToggleRememberMicrophoneAccess: this.props.personalToggleRememberMicrophoneAccess, metaMedia: metaMedia }, metaMedia.name))) })), hasPhoneChannel && (_jsx(_Fragment, { children: _jsx("span", Object.assign({ className: "simultaneous-ring badge-item no-margin" }, { children: _jsx(Tooltip, Object.assign({ content: simultaneousRingingText, dark: true, wrap: "none" }, { children: _jsx("span", Object.assign({ style: {
                                            display: 'inline-flex',
                                            verticalAlign: 'middle',
                                        }, onClick: () => {
                                            validPhoneNumber == true && isInTrial === false
                                                ? this.toggleSimultaneousRing()
                                                : null;
                                        } }, { children: _jsx(Icon, { name: "simultaneous", size: 24, className: `${simultaneousRingingActiveBadge} profile-presence-icon-big badge-btn` }) })) })) })) }))] }))), _jsx(PresenceDropdown, { presence: this.props.presence, profile: profile, metaWorkingMedia: metaWorkingMedia, telephony: this.props.telephony, presenceSetMedia: this.props.presenceSetMedia, presenceSetMediaChannel: this.props.presenceSetMediaChannel, errorMicrophoneErrorShowModal: this.props.errorMicrophoneErrorShowModal, personalToggleRememberMicrophoneAccess: this.props.personalToggleRememberMicrophoneAccess, validPhoneNumber: validPhoneNumber, isInTrial: isInTrial, toggleSimultaneousRing: this.toggleSimultaneousRing, hasPhoneChannel: hasPhoneChannel, changeYourStatus: this.changeYourStatus, statusText: this.props.presence.status, oppositePresenceStatus: oppositePresenceStatus, showLogoutModal: this.props.showLogoutModal })] })));
    }
}
__decorate([
    boundMethod
], Profile.prototype, "changeYourStatus", null);
__decorate([
    boundMethod
], Profile.prototype, "toggleSimultaneousRing", null);
export default Profile;
